import IconButton from '@mui/material/IconButton'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

type SignupCardProps = {
  headerComponent?: JSX.Element
  hasBackButton?: boolean
  onBack?: React.MouseEventHandler<HTMLButtonElement>
  iconSrc?: string
  heading: string | JSX.Element
  subheading?: string
  children?: React.ReactNode
}

export const SignupCard = ({
  headerComponent,
  hasBackButton = false,
  onBack,
  iconSrc,
  heading,
  subheading,
  children,
}: SignupCardProps): JSX.Element => (
  <article className='md:max-w-[460px] w-full md:w-[460px] lg:w-auto relative bg-white md:rounded-xl col-span-12 lg:col-span-5 px-8 md:px-12 lg:px-8 xl:px-12 py-16 h-full md:h-auto'>
    {hasBackButton && (
      <div className='mb-8'>
        <IconButton
          size='medium'
          edge='start'
          sx={{ position: 'absolute', top: 34 }}
          onClick={onBack}
        >
          <ArrowBackIosNewIcon fontSize='inherit' />
        </IconButton>
      </div>
    )}
    {headerComponent}
    {iconSrc && <img className='mb-8 max-w-[140px]' src={iconSrc} />}
    {heading && (
      <h1 className='text-3xl w-80 max-w-fit leading-snug mb-4'>{heading}</h1>
    )}
    {subheading && (
      <p className='text-sm font-extralight leading-relaxed text-body-black mb-4 ml-0.5'>
        {subheading}
      </p>
    )}
    <div className='pt-4'>{children}</div>
  </article>
)
